import "./ResponseDialog.scss";

import { FunctionComponent, useEffect, useState } from "react";
import Dialog from "../Dialog/Dialog";
import ButtonField from "../Button/ButtonField";
import { IAPIResponse } from "../../Redux/interfaces/IAPIResponse";
import { SvgIcon } from "@mui/material";
import { ReactComponent as Success } from "../../Assets/Images/success.svg";
import { ReactComponent as Failure } from "../../Assets/Images/failure.svg";

interface ResponseDialogProps {
  response?: IAPIResponse<any>;
  parentDialog?: React.Dispatch<React.SetStateAction<boolean>> | (() => void);
  onClose?: () => void;
}

const ResponseDialog: FunctionComponent<ResponseDialogProps> = (props) => {
  const { response, parentDialog, onClose } = props;
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
    
    // Call onClose callback if provided (preferred method)
    if (onClose) {
      onClose();
    }
    // Support legacy parentDialog prop
    else if (response?.responseMessage == 'success' && parentDialog) {
      // Check function signature length to determine type
      const funcLength = (parentDialog as any).length;
      
      if (funcLength === 0 || funcLength === undefined) {
        // It's a callback function: () => void
        (parentDialog as () => void)();
      } else {
        // It's a state setter: React.Dispatch<React.SetStateAction<boolean>>
        (parentDialog as React.Dispatch<React.SetStateAction<boolean>>)(false);
      }
    }
  };

  useEffect(() => {
    if (response && Object.keys(response).length !== 0) {
      setOpen(true);
    }
  }, [response]);

  // Determine if response is successful
  const isSuccess = response?.responseMessage === 'success' || 
                    response?.responseCode === 200 || 
                    (response?.response?.status === true && response?.responseCode !== undefined && response?.responseCode >= 200 && response?.responseCode < 300);

  // Get success message
  const successMessage = response?.response?.message || 
                        response?.response?.data?.message || 
                        response?.message || 
                        'Operation completed successfully';

  // Get error message — covers both direct API responses and Axios error objects
  const errorMessage = response?.response?.error ||
                      response?.response?.data?.error ||
                      (typeof response?.response?.data?.response === 'string' ? response.response.data.response : null) ||
                      (typeof response?.response === 'string' ? response.response : null) ||
                      'Something went wrong! Try After Some Time';

  return (
    <Dialog
      open={open}
      dialogContentClassName="response_content"
      Dialog_Content={
        <>
          {isSuccess ? successMessage : errorMessage}
          <SvgIcon
            component={isSuccess ? Success : Failure}
            inheritViewBox
            className="response_icon"
          />
        </>
      }
      Dialog_Actions={
        <ButtonField
          className="response_button"
          onClick={() => handleClose()}>
          OK
        </ButtonField>
      }
    />
  );
};

export default ResponseDialog;
